import { Quill } from 'react-quill';

const Link = Quill.import('formats/link');

export default class LinkSanitizer extends Link {
  static sanitize(url: string) {
    // Run default sanitize method from Quill
    const sanitizedUrl = super.sanitize(url);

    // Verify if the URL already starts with http
    if (sanitizedUrl.startsWith('http')) return sanitizedUrl;

    // if not, then append only 'http' so that it's not a relative url
    return `http://${sanitizedUrl}`;
  }
}

Quill.register('formats/link', LinkSanitizer);
